import useDownloadFile from './useDownloadFile';

export default useDownloadFile;
